import React, { useState } from 'react';
import '../../assests/css/customer/UserAddress.css';

const UserAddress = () => {
  const [addresses, setAddresses] = useState({
    billing: [
      {
        id: 1,
        company: 'YourCompany',
        name: 'Mitchell Admin',
        street: '215 Vine St',
        city: 'Scranton',
        state: 'PA',
        zip: '18503',
        country: 'United State'
      }
    ],
    shipping: [
      {
        id: 1,
        company: 'YourCompany',
        name: 'Mitchell Admin',
        street: '215 Vine St',
        city: 'Scranton',
        state: 'PA',
        zip: '18503',
        country: 'United States'
      }
    ]
  });

  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState('');
  const [editingAddress, setEditingAddress] = useState(null);
  const [formData, setFormData] = useState({
    company: '',
    name: '',
    street: '',
    city: '',
    state: '',
    zip: '',
    country: ''
  });

  const handleAddAddress = (type) => {
    setModalType(type);
    setEditingAddress(null);
    setFormData({
      company: '',
      name: '',
      street: '',
      city: '',
      state: '',
      zip: '',
      country: ''
    });
    setShowModal(true);
  };

  const handleEditAddress = (type, address) => {
    setModalType(`edit-${type}`);
    setEditingAddress(address);
    setFormData(address);
    setShowModal(true);
  };

  const handleRemoveAddress = (type, addressId) => {
    const confirmDelete = window.confirm('Are you sure you want to remove this address?');
    if (confirmDelete) {
      setAddresses(prev => ({
        ...prev,
        [type]: prev[type].filter(addr => addr.id !== addressId)
      }));
    }
  };

  const handleFormChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSaveAddress = () => {
    if (!formData.company || !formData.name || !formData.street || !formData.city || !formData.state || !formData.zip || !formData.country) {
      alert('Please fill in all fields');
      return;
    }

    const isBilling = modalType.includes('billing');
    const addressType = isBilling ? 'billing' : 'shipping';

    if (modalType.startsWith('edit')) {
      setAddresses(prev => ({
        ...prev,
        [addressType]: prev[addressType].map(addr =>
          addr.id === editingAddress.id ? { ...formData, id: addr.id } : addr
        )
      }));
      alert('Address updated successfully!');
    } else {
      const newAddress = {
        ...formData,
        id: Date.now()
      };
      setAddresses(prev => ({
        ...prev,
        [addressType]: [...prev[addressType], newAddress]
      }));
      alert('Address added successfully!');
    }

    setShowModal(false);
    setFormData({
      company: '',
      name: '',
      street: '',
      city: '',
      state: '',
      zip: '',
      country: ''
    });
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingAddress(null);
  };

  return (
   
      <div className="addrmgmt-content-only">
        {/* Billing Address Section */}
        <div className="addrmgmt-section">
          <h2 className="addrmgmt-section-title">Billing Address</h2>
          
          <button 
            className="addrmgmt-add-btn"
            onClick={() => handleAddAddress('add-billing')}
          >
            <span className="addrmgmt-add-icon">+</span>
            Add an address
          </button>

          <div className="addrmgmt-cards-wrapper">
            {addresses.billing.map((address) => (
              <div key={address.id} className="addrmgmt-card">
                <div className="addrmgmt-card-content">
                  <p className="addrmgmt-card-line">{address.company}, {address.name}</p>
                  <p className="addrmgmt-card-line">{address.street}</p>
                  <p className="addrmgmt-card-line">{address.city} {address.state} {address.zip}</p>
                  <p className="addrmgmt-card-line">{address.country}</p>
                </div>
                <button 
                  className="addrmgmt-edit-btn"
                  onClick={() => handleEditAddress('billing', address)}
                  title="Edit Address"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                  </svg>
                </button>
                
                <div className="addrmgmt-card-actions">
                  <button 
                    className="addrmgmt-card-edit-btn"
                    onClick={() => handleEditAddress('billing', address)}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                    </svg>
                    Edit
                  </button>
                  <button 
                    className="addrmgmt-card-remove-btn"
                    onClick={() => handleRemoveAddress('billing', address.id)}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polyline points="3 6 5 6 21 6"></polyline>
                      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                      <line x1="10" y1="11" x2="10" y2="17"></line>
                      <line x1="14" y1="11" x2="14" y2="17"></line>
                    </svg>
                    Remove
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Shipping Address Section */}
        <div className="addrmgmt-section">
          <h2 className="addrmgmt-section-title">Shipping Address</h2>
          
          <button 
            className="addrmgmt-add-btn"
            onClick={() => handleAddAddress('add-shipping')}
          >
            <span className="addrmgmt-add-icon">+</span>
            Add an address
          </button>

          <div className="addrmgmt-cards-wrapper">
            {addresses.shipping.map((address) => (
              <div key={address.id} className="addrmgmt-card">
                <div className="addrmgmt-card-content">
                  <p className="addrmgmt-card-line">{address.company}, {address.name}</p>
                  <p className="addrmgmt-card-line">{address.street}</p>
                  <p className="addrmgmt-card-line">{address.city} {address.state} {address.zip}</p>
                  <p className="addrmgmt-card-line">{address.country}</p>
                </div>
                <button 
                  className="addrmgmt-edit-btn"
                  onClick={() => handleEditAddress('shipping', address)}
                  title="Edit Address"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                  </svg>
                </button>
                
                <div className="addrmgmt-card-actions">
                  <button 
                    className="addrmgmt-card-edit-btn"
                    onClick={() => handleEditAddress('shipping', address)}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                    </svg>
                    Edit
                  </button>
                  <button 
                    className="addrmgmt-card-remove-btn"
                    onClick={() => handleRemoveAddress('shipping', address.id)}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polyline points="3 6 5 6 21 6"></polyline>
                      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                      <line x1="10" y1="11" x2="10" y2="17"></line>
                      <line x1="14" y1="11" x2="14" y2="17"></line>
                    </svg>
                    Remove
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Modal for Add/Edit Address */}
        {showModal && (
          <div className="addrmgmt-modal-overlay" onClick={handleCloseModal}>
            <div className="addrmgmt-modal" onClick={(e) => e.stopPropagation()}>
              <div className="addrmgmt-modal-header">
                <h3 className="addrmgmt-modal-title">
                  {modalType.startsWith('edit') ? 'Edit Address' : 'Add New Address'}
                </h3>
                <button className="addrmgmt-modal-close" onClick={handleCloseModal}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>

              <div className="addrmgmt-modal-body">
                <div className="addrmgmt-form-row">
                  <div className="addrmgmt-form-group">
                    <label className="addrmgmt-label">Company Name *</label>
                    <input
                      type="text"
                      className="addrmgmt-input"
                      value={formData.company}
                      onChange={(e) => handleFormChange('company', e.target.value)}
                      placeholder="Enter company name"
                    />
                  </div>

                  <div className="addrmgmt-form-group">
                    <label className="addrmgmt-label">Full Name *</label>
                    <input
                      type="text"
                      className="addrmgmt-input"
                      value={formData.name}
                      onChange={(e) => handleFormChange('name', e.target.value)}
                      placeholder="Enter full name"
                    />
                  </div>
                </div>

                <div className="addrmgmt-form-group">
                  <label className="addrmgmt-label">Street Address *</label>
                  <input
                    type="text"
                    className="addrmgmt-input"
                    value={formData.street}
                    onChange={(e) => handleFormChange('street', e.target.value)}
                    placeholder="Enter street address"
                  />
                </div>

                <div className="addrmgmt-form-row">
                  <div className="addrmgmt-form-group">
                    <label className="addrmgmt-label">City *</label>
                    <input
                      type="text"
                      className="addrmgmt-input"
                      value={formData.city}
                      onChange={(e) => handleFormChange('city', e.target.value)}
                      placeholder="Enter city"
                    />
                  </div>

                  <div className="addrmgmt-form-group">
                    <label className="addrmgmt-label">State *</label>
                    <input
                      type="text"
                      className="addrmgmt-input"
                      value={formData.state}
                      onChange={(e) => handleFormChange('state', e.target.value)}
                      placeholder="Enter state"
                    />
                  </div>
                </div>

                <div className="addrmgmt-form-row">
                  <div className="addrmgmt-form-group">
                    <label className="addrmgmt-label">ZIP Code *</label>
                    <input
                      type="text"
                      className="addrmgmt-input"
                      value={formData.zip}
                      onChange={(e) => handleFormChange('zip', e.target.value)}
                      placeholder="Enter ZIP code"
                    />
                  </div>

                  <div className="addrmgmt-form-group">
                    <label className="addrmgmt-label">Country *</label>
                    <input
                      type="text"
                      className="addrmgmt-input"
                      value={formData.country}
                      onChange={(e) => handleFormChange('country', e.target.value)}
                      placeholder="Enter country"
                    />
                  </div>
                </div>
              </div>

              <div className="addrmgmt-modal-footer">
                <button className="addrmgmt-cancel-btn" onClick={handleCloseModal}>
                  Cancel
                </button>
                <button className="addrmgmt-save-btn" onClick={handleSaveAddress}>
                  {modalType.startsWith('edit') ? 'Update Address' : 'Add Address'}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
  );
};

export default UserAddress;